/**
 * コンポーネントデータ
 * @param appliedAamDiscountCode 適用済AAMプロモーションコード
 */
export interface PaymentAmountData {
  appliedAamDiscountCode?: string;
}

export function initPaymentAmountData(): PaymentAmountData {
  return {
    appliedAamDiscountCode: '',
  };
}

export interface PaymentAmountParts {
  appliedDiscountType: string;
  appliedAamDiscountCode?: string;
}

export function initPaymentAmountParts(): PaymentAmountParts {
  return {
    appliedDiscountType: '',
    appliedAamDiscountCode: '',
  };
}
